import { WorkWithUsActions } from "./action";

const initialState = {
  WorkwithusData: [],
};

export const WorkWithUsReducer = (state = initialState, action) => {
  switch (action.type) {
    case WorkWithUsActions.SET_WORK_WITH_US:
      return {
        ...state,
        WorkwithusData: action.payload,
      };
    default:
      return state;
  }
};
